<div class="container" id="print-section">
  <table class="table table-bordered">
    <!-- <ng-container *ngIf="repDataList && repDataList.length > 0"> -->
    <thead>
          <tr>
              <!-- <th colspan="11" style="text-align: center; font-size: 14px;">विवेक साप्ताहिक</th> -->
               <th colspan="6" style="text-align: center; font-size: 14px;">विवेक साप्ताहिक</th>
          </tr>
        
          <!-- <tr> //Old Code
            <th colspan="3" style="text-align: center; font-size: 12px;">पत्ता सूची</th>
            <th colspan="4" style="text-align: left; font-size: 12px;">{{ country }} | {{state}} | {{ district }} |
               {{ taluka }} | {{pincode}} | {{rep_name}} | {{prant_name}} | {{delivery_mode}} | {{sub_type}}</th>
            <th colspan="4" style="text-align: center; font-size: 12px;">दिनांक : {{ start_date | date: 'dd-MM-yyyy'}} ते {{ end_date | date: 'dd-MM-yyyy'}} </th>
          </tr> -->

           <tr>
            <th colspan="3" style="text-align: center; font-size: 12px;">पत्ता सूची</th>
            <th colspan="1" style="text-align: left; font-size: 12px;">{{ country }} | {{state}} | {{ district }} |
               {{ taluka }} | {{pincode}} | {{rep_name}} | {{prant_name}} | {{delivery_mode}} | {{sub_type}}</th>
            <th colspan="2" style="text-align: center; font-size: 12px;">दिनांक : {{ start_date | date: 'dd-MM-yyyy'}} ते {{ end_date | date: 'dd-MM-yyyy'}} </th>
          </tr>
         
         
          <tr>
            <td style="text-align: center; font-weight: bold;">अ.क्रमांक</td>
            <td style="text-align: center; font-weight: bold;">वर्गणीदार क्रमांक</td>
            <td style="text-align: center; font-weight: bold;">वर्गणीदारचे नाव</td>
            <td style="text-align: center; font-weight: bold;">पत्ता </td>
           <!-- <td style="text-align: center; font-weight: bold;">पिन कोड</td>
             <td style="text-align: center; font-weight: bold;">तालूका</td>
            <td style="text-align: center; font-weight: bold;">जिल्हा</td>
            <td style="text-align: center; font-weight: bold;">राज्य</td>
            <td style="text-align: center; font-weight: bold;">देश</td> -->
            <td style="text-align: center; font-weight: bold;">मोबाईल नंबर </td>
            <td style="text-align: center; font-weight: bold;">वैध दिनांक</td>
            <!-- <td style="text-align: center; font-weight: bold;">महिना</td> -->
            <!-- <td style="text-align: center; font-weight: bold;">प्रांतचे नाव</td> -->
          </tr> 
      </thead>

      <!-- <tbody *ngFor="let data2 of allAddList; let i = index"> -->
          
        <tr *ngFor="let data2 of allAddList; let i = index">
          <td style="padding: 8px; text-align: right;">{{i + 1}}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.sub_no }}</td>
          <td style="padding: 8px;">{{data2.name}}</td>
          <td style="padding: 8px;">{{data2.address}}, {{data2.taluka}},{{data2.district}},{{data2.pincode}},{{data2.state}},{{data2.country}}.</td>
          <!-- <td style="padding: 8px; text-align: right;">{{data2.pincode}}</td>
          <td style="padding: 8px; text-align: right;">{{data2.taluka}}</td>
          <td style="padding: 8px; text-align: right;">{{data2.district}}</td>
          <td style="padding: 8px; text-align: right;">{{data2.state}}</td>
          <td style="padding: 8px; text-align: right;">{{data2.country}}</td> -->
          <td style="padding: 8px; text-align: right;">{{data2.mobileNumber}}</td>
          <td style="padding: 8px;">{{ data2.start_period | date:'dd/MM/yyyy' }} - {{ data2.end_period | date:'dd/MM/yyyy' }}</td>
          <!-- <td style="padding: 8px;">{{data2.month}}</td>
          <td style="padding: 8px;">{{data2.prant_name}}</td> -->
        </tr>
      <!-- </tbody> -->

      <!-- <tbody *ngFor="let data2 of repDataList; let i = index">
        <tr>
          <td style="padding: 8px; text-align: right;">{{ i + 1 }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.subscription_Number }}</td>
          <td style="padding: 8px;">{{ data2.name }}</td>
          <td style="padding: 8px;">{{ data2.address }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.pincode }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.country }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.state }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.district }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.taluka }}</td>
          <td style="padding: 8px; text-align: right;">{{ data2.mobileNumber }}</td>
          <td style="padding: 8px;">{{ data2.start_period | date:'dd/MM/yyyy' }} - {{ data2.end_period | date:'dd/MM/yyyy' }}</td> -->
          <!-- <td style="padding: 8px; text-align: right;">{{ data2.Month }}</td> -->
          <!-- <td style="padding: 8px;">{{ data2.prant_name }}</td> -->
        <!-- </tr>
      </tbody> -->

    <!-- </ng-container> -->
  </table>

  <div style="margin-left: 50%;  margin-bottom: 2%">

    <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
    (click)="exportExcel('Address Label Report')" mat-raised-button color="primary">
    Export
</button>

      <button class="noPrint"
      style="margin-top: 2%; margin-left: 2%"
      mat-raised-button color="primary"
      (click)="printPage()">
       Print
     </button>

      <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
          Close
      </button>
</div>

</div>